export interface WorldpayIframeFormValue {
  cardNumber: string;
  cardHolderName: string;
  cardExpiryMonth: number;
  cardExpiryYear: number;
  cardSecurityCode: string;
}
